<template>
	<div class="node-manage-wrap">
		<Nav
			:subNav="isShowDeviceSetting ? '设备详情' : '设备管理'"
			:isShowBack="isShowDeviceSetting"
			@goBack="goBack"
		></Nav>
		<template v-if="false">
			<div class="info-title" @click="closeNodeManageClick" v-if="false">
				我的设备
				<span>（{{ listOnline.length }}/{{ listTotal.length }}）</span>
			</div>
			<div class="check-wrap">
				<div
					class="check-btn check-btn1"
					:class="{ active: checkFlag == 1 }"
					@click="checkClick(1)"
				>
					全部（{{ listTotal.length }}）
				</div>
				<div
					class="check-btn"
					:class="{ active: checkFlag == 2 }"
					@click="checkClick(2)"
				>
					在线（{{ listOnline.length }}）
				</div>
				<div
					class="check-btn"
					:class="{ active: checkFlag == 3 }"
					@click="checkClick(3)"
				>
					离线（{{ listOffline.length }}）
				</div>
				<div class="check-btn add-device-btn" @click="onAddClick">
					添加设备
				</div>
			</div>
			<div class="service-group-wrap">
				<div class="service-group">
					<div
						v-bind:key="index"
						v-for="(item, index) in list"
						class="service-item"
					>
						<div class="item-name-group">
							<div class="item-icon">
								<div class="device-status-wrap">
									<div
										:class="{
											'device-icon': true,
											'device-icon-off':
												item.term.status == 1,
										}"
									>
										<div
											:class="{
												'device-status': true,
												'device-status-off':
													item.term.status == 1,
											}"
										>
											<div v-if="item.term.status == 1">
												离线
											</div>
											<div v-else>在线</div>
										</div>
									</div>
								</div>
							</div>
							<div class="item-text">
								<div class="item-name">
									{{
										item.term.comment
											? item.term.comment
											: item.term.name
											? item.term.name
											: item.peerid
									}}
								</div>
								<div class="item-ip">
									IP：{{
										item.ip
											? $common.ipConvert(item.ip)
											: ""
									}}
								</div>
							</div>

							<div
								class="xbjf_btn"
								@click="goXbjf(item, index, 'show')"
							>
								小宝积分
							</div>

							<div
								class="unbind"
								@click="
									showOrHideSettingTipClick(
										item,
										index,
										'show'
									)
								"
							>
								管理
							</div>
						</div>
					</div>
					<div class="add-device-btn2" @click="onAddClick">
						添加绑定设备
					</div>
				</div>
			</div>
		</template>
		<BindLimitAlert
			@onCancelClick="hideBindLimitAlert"
			@onPayClick="onPayClick"
			v-if="isShowBindLimitAlert"
		></BindLimitAlert>
		<MessageTip
			v-if="messageFlag"
			:messageType="messageType"
			@closeMessageAlertClick="closeMessageAlertClick"
			@doUnbindClick="doUnbindClick"
			@goPay="onPayClick"
			:unbindDevName="unbindDevName"
		></MessageTip>
		<DeviceSettingTip
			v-if="isShowDeviceSetting && unbindItem"
			@cacheCleanClick="cacheCleanClick"
			@doUnbindClick="doUnbindClick"
			@showOrHideSettingTipClick="showOrHideSettingTipClick"
			:unbindItem="unbindItem"
			:unbindDevName="unbindDevName"
			:peerid="cur_pid"
			:peerItem="unbindItem"
			@visitClick="visitClick"
		></DeviceSettingTip>
		<DeviceSettingBind
			v-if="isShowBindAlert"
			@showOrHideBindClick="showOrHideBindClick"
			@bindDeviceClick="bindDeviceClick"
		></DeviceSettingBind>
		<Control
			:dev="controlDev"
			:item="controlItem"
			:type="controlType"
			@closeClick="hideControl"
			v-if="isShowControl && controlItem"
		></Control>
		<div class="tip-text" v-if="tipText">{{ tipText }}</div>
		<div v-if="isBindSuccess == 1" class="bind-result-wrap">
			<div class="bind-result-text1">绑定成功</div>
			<div>若未自动跳转请刷新页面</div>
		</div>
		<div v-else-if="isBindSuccess == 2" class="bind-result-wrap">
			<div class="bind-result-text1">绑定失败</div>
			<div>绑定码错误或失效</div>
		</div>
		<div class="node-loading" v-if="isLoading">
			<img src="../assets/home/node/loading.gif" />
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import MessageTip from "@/components/MessageTip.vue";
import DeviceSettingTip from "@/components/DeviceSettingTip.vue";
import DeviceSettingBind from "@/components/DeviceSettingBind.vue";
import Nav from "@/components/Common/Nav.vue";
import BindLimitAlert from "@/components/Node/BindLimitAlert.vue";
import Control from "@/components/Node/Control.vue";

export default {
	components: {
		MessageTip,
		DeviceSettingTip,
		DeviceSettingBind,
		Nav,
		BindLimitAlert,
		Control,
	},
	props: {},
	data: function () {
		return {
			isLoading: false,
			cur_pid: this.$route.query.cur_pid ? this.$route.query.cur_pid : "",
			unbindDevName: "",
			messageFlag: false, //true显示弹框，false不显示
			messageType: "", //弹框类型：显示安装nas插件弹框（showInstallNasPlugin）
			list: [], //设备列表
			unbindItem: {}, //要解绑的服务
			unbindIndex: null, //要解绑的服务index
			isShowDeviceSetting: false,
			isShowBindLimitAlert: false,
			tipText: "",
			isShowBindAlert: false,
			listOffline: [], //离线设备列表
			listOnline: [], //在线设备列表
			listTotal: [], //全部设备列表
			checkFlag: 1, //1显示全部设备 2显示在线设备列表 3显示离线设备列表
			isBindSuccess: 0, //1绑定成功 2绑定失败
			isShowControl: false,
			controlItem: null,
			controlDev: null,
			controlType: null,
		};
	},
	computed: {},
	methods: {
		...mapActions([
			"bindset",
			"bindget",
			"nodeUnbind",
			"sendUserlog",
			"cacheclean",
			"bookRegister",
			"portal",
			"createTunnel",
			"startMapSrv",
		]),
		showBindLimitAlert: function () {
			this.isShowBindLimitAlert = true;
		},
		hideBindLimitAlert: function () {
			this.isShowBindLimitAlert = false;
		},
		onPayClick: function () {
			let _that = this;
			_that.$router.push({ path: "/home/vip" });
		},
		onAddClick: function () {
			let _that = this;
			if (
				_that.$store.state.user.vip_left <= 0 &&
				_that.list.length >= 1
			) {
				this.showBindLimitAlert();
			} else {
				this.showOrHideBindClick(true);
			}
		},
		showControl: function () {
			this.isShowControl = true;
		},
		hideControl: function () {
			this.isShowControl = false;
		},
		visitClick: function (data) {
			let _that = this;
			let item = null;
			for (
				let index = 0;
				index < _that.$store.state.bind_list.length;
				index++
			) {
				const element = _that.$store.state.bind_list[index];
				if (element.peerid == data.peerid) {
					// console.log(element);
					item = element.control_item;
					if (item) {
						_that.controlDev = item.dev;
						_that.controlItem = item;
						_that.controlType = "control";
						_that.showControl();
					}
					break;
				}
			}
			// _that.$emit("visitClick", data);
		},
		checkClick: function (data) {
			let _that = this;
			_that.checkFlag = data;
			if (data == 1) {
				let o = JSON.parse(JSON.stringify(_that.listTotal));
				_that.list = o;
			} else if (data == 2) {
				let o = JSON.parse(JSON.stringify(_that.listOnline));
				_that.list = o;
			} else {
				let o = JSON.parse(JSON.stringify(_that.listOffline));
				_that.list = o;
			}
		},
		bindDeviceClick: function (data) {
			let _that = this;

			_that.bookRegister([
				data,
				function (err, data) {
					if (data && !data.rtn && data.register) {
						_that.isBindSuccess = 1;
						setTimeout(function () {
							_that.isBindSuccess = 0;
						}, 2000);
						_that.getBind();
					} else {
						// 绑定失败
						if (data && data.rtn == 10216) {
							// 数量限制
							_that.messageFlag = true;
							_that.messageType = "showBindLimit";
						} else {
							_that.isBindSuccess = 2;
							setTimeout(function () {
								_that.isBindSuccess = 0;
							}, 2000);
						}
					}
				},
			]);
		},
		showOrHideBindClick: function (data) {
			let _that = this;
			_that.isShowBindAlert = data;
		},
		cacheCleanClick: function (size, switching) {
			let _that = this;

			_that.cacheclean([
				_that.unbindItem.peerid,
				size,
				function (err, data) {
					if (data && data.rtn == 0) {
						// _that.tipText = "正在清除缓存，请稍后";
						// setTimeout(function () {
						// 	_that.tipText = "";
						// }, 2000);
					}
				},
			]);

			// 不用校验普通模式
			//获取上传速度
			// if (switching && switching == 1) {
			// 	_that.cacheclean([
			// 		_that.unbindItem.peerid,
			// 		size,
			// 		function (err, data) {
			// 			if (data && data.rtn == 0) {
			// 				_that.tipText = "正在清除缓存，请稍后";
			// 				setTimeout(function () {
			// 					_that.tipText = "";
			// 				}, 2000);
			// 			}
			// 		},
			// 	]);
			// } else {
			// 	_that.tipText = "请切换至望远镜模式后再清除缓存";
			// 	setTimeout(function () {
			// 		_that.tipText = "";
			// 	}, 2000);
			// }
		},
		showOrHideSettingTipClick: function (item, index, showOrHideFlag) {
			let _that = this;
			_that.isShowDeviceSetting = false;
			if (showOrHideFlag == "show") {
				let itemDeepCopy = JSON.parse(JSON.stringify(item));
				if (itemDeepCopy.ip) {
					let ip = itemDeepCopy.ip;
					itemDeepCopy.noConvertIp = ip;
					itemDeepCopy.ip = _that.$common.ipConvert(ip);
				}
				// console.log("showOrHideSettingTipClick", _that.unbindItem);
				_that.unbindItem = itemDeepCopy;
				// console.log("showOrHideSettingTipClick", _that.unbindItem);
				_that.unbindIndex = index;
				_that.unbindDevName = itemDeepCopy.term.name
					? itemDeepCopy.term.name
					: itemDeepCopy.peerid;
				_that.isShowDeviceSetting = true;
			} else {
				_that.getBind();
				_that.isShowDeviceSetting = false;
			}
		},
		goBack: function () {
			if (this.cur_pid) {
				this.$router.back(-1);
			} else if (this.isShowDeviceSetting) {
				this.showOrHideSettingTipClick("", "", "hide");
			} else {
				this.$router.back(-1);
			}
		},
		goXbjf: function (item) {
			let _that = this;
			_that.$router.push({
				path: "/home/speedshare",
				query: { cur_pid: item.peerid },
			});
		},
		closeNodeManageClick: function () {
			let _that = this;
			_that.$emit("closeNodeManageClick");
		},
		closeMessageAlertClick: function () {
			let _that = this;
			_that.messageFlag = false;
		},
		unbindClick: function (item, index) {
			let _that = this;
			_that.sendUserlog(["unbind_click", item.peerid]);
			_that.messageFlag = true;
			_that.messageType = "showUnbind";
			_that.unbindItem = item;
			_that.unbindIndex = index;
			_that.unbindDevName = item.term.name ? item.term.name : item.peerid;
		},
		doUnbindClick: function () {
			let _that = this;
			_that.messageFlag = false;

			// let del = [];
			// del.push(_that.unbindItem.peerid);

			// _that.bindset([
			// 	del,
			// 	function (err, data) {
			// 		if (data && !data.rtn) {
			// 			_that.list.splice(_that.unbindIndex, 1);
			// 		}
			// 	},
			// ]);

			_that.isLoading = true;

			_that.nodeUnbind([
				_that.unbindItem.peerid,
				function (err, data) {
					_that.isLoading = false;
					if (data && !data.rtn) {
						_that.sendUserlog([
							"unbindDevice_s",
							_that.unbindItem.peerid,
						]);
						_that.list.splice(_that.unbindIndex, 1);
						if (_that.list.length <= 0) {
							_that.closeNodeManageClick();
						}
						_that.tipText = "解绑成功";
						setTimeout(function () {
							_that.tipText = "";
						}, 2000);
						_that.getBind();
						_that.goBack();
					}
				},
			]);
		},
		getBind: function () {
			let _that = this;
			// return;
			_that.isLoading = true;
			_that.bindget([
				function (err, data) {
					_that.isLoading = false;
					if (data && data.terms && data.terms.length > 0) {
						_that.list = data.terms;
						_that.$store.state.bind_list = data.terms;
						_that.listTotal = data.terms;
						_that.listOffline = [];
						_that.listOnline = [];

						for (
							let index = 0;
							index < _that.list.length;
							index++
						) {
							const element = _that.list[index];
							element.ip = "";
							element.mac = "";
							if (element.term && element.term.nic) {
								let nic = _that.$common.getNicByNics(
									element.term.nic
								);
								if (nic) {
									element.ip = nic.ipv4n;
									element.mac = nic.mac;
								}
							}

							if (
								element.term.status &&
								element.term.status == 1
							) {
								_that.listOffline.push(element);
							} else {
								_that.listOnline.push(element);
							}
							if (element.term && element.term.comment) {
								if (element.term.comment == "0") {
									element.term.comment = "";
								}
							}
						}

						if (_that.cur_pid) {
							// console.log("_that.cur_pid", _that.cur_pid);
							for (
								let index = 0;
								index < _that.list.length;
								index++
							) {
								const element = _that.list[index];
								if (_that.cur_pid == element.peerid) {
									_that.showOrHideSettingTipClick(
										element,
										index,
										"show"
									);
									break;
								}
							}
						}
					}
				},
			]);
		},
	},
	activated() {
		let _that = this;
		_that.cur_pid = this.$route.query.cur_pid
			? this.$route.query.cur_pid
			: "";
		if (_that.cur_pid) {
			_that.isShowDeviceSetting = true;
		}
		_that.unbindItem = null;
		_that.getBind();
	},
	mounted() {
		let _that = this;
		_that.getBind();
	},
};
</script>

<style scoped lang="less">
.node-loading {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	text-align: center;
	z-index: 9;
	background-color: rgba(255, 255, 255, 0.3);
	img {
		margin-top: 280px;
	}
}
.node-manage-wrap {
	height: 100%;
	box-sizing: border-box;
	background-color: #f5f5f5;

	.tip-text {
		position: absolute;
		top: 300px;
		left: 50%;
		margin-left: -90px;
		z-index: 10;
		padding-left: 31px;
		padding-right: 31px;
		font-size: 12px;
		color: #f5f5f5;
		background-color: rgba(102, 102, 102, 0.8);
		height: 49px;
		line-height: 49px;
		border-radius: 3px;
	}

	.bind-result-wrap {
		position: absolute;
		padding-top: 18px;
		text-align: center;
		height: 78px;
		width: 208px;
		top: 50%;
		left: 50%;
		margin-left: -104px;
		margin-top: -39px;
		z-index: 10;
		padding-left: 31px;
		padding-right: 31px;
		font-size: 12px;
		color: #f5f5f5;
		background-color: rgba(102, 102, 102, 0.8);
		border-radius: 3px;
		box-sizing: border-box;

		.bind-result-text1 {
			margin-bottom: 8px;
			font-size: 14px;
			font-weight: 700;
		}
	}

	.info-title {
		position: relative;
		color: #1c1f28;
		font-size: 14px;
		padding-left: 71px;
		height: 20px;
		line-height: 20px;

		span {
			color: #1f5de3;
		}
	}
	.info-title::before {
		content: "";
		position: absolute;
		left: 14px;
		top: 1px;
		background-image: url("../assets/home/node/device6.svg");
		width: 18px;
		height: 18px;
		cursor: pointer;
		background-position: center;
		background-size: 100% 100%;
		background-repeat: no-repeat;
		box-sizing: border-box;
	}
	.info-title::after {
		content: "";
		position: absolute;
		left: 48px;
		top: 2px;
		width: 16px;
		height: 16px;
		background-image: url("../assets/home/node/device5.svg");
		background-position: center;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.check-wrap {
		margin-left: 10px;
		margin-right: 10px;
		margin-top: 4px;
		height: 60px;
		line-height: 60px;
		font-size: 12px;
		border-radius: 3px;
		border-top: 1px solid #dbdfe7;

		div {
			display: inline-block;
			cursor: pointer;
			text-align: center;
		}
		.check-btn {
			margin-left: 10px;
			width: 92px;
			height: 32px;
			line-height: 31px;
			background-color: #e6e6e6;
			border-radius: 20px;
			color: #666666;
			font-size: 12px;
		}
		.check-btn1 {
			margin-left: 0px;
		}

		.add-device-btn {
			position: relative;
			margin-right: 40px;
			padding-left: 22px;
			width: 102px;
			background-color: #1f5de3;
			color: #f5f5f5;
			box-sizing: border-box;
			float: right;
			margin-top: 15px;
		}
		.add-device-btn::before {
			content: "";
			position: absolute;
			top: 5px;
			left: 14px;
			width: 20px;
			height: 20px;
			background-image: url("../assets/home/node/device1.svg");
			background-size: 100% 100%;
			background-repeat: no-repeat;
			background-position: center;
		}
		.check-btn.active,
		.check-btn:hover {
			background-color: #cfe2ff;
			color: #1f5de3;
		}

		.add-device-btn:hover {
			background-color: #1f5de3;
			color: #f5f5f5;
			opacity: 0.8;
		}
	}

	.service-group-wrap {
		position: relative;
		height: 432px;
		margin-left: 10px;
		margin-right: 10px;
		background-color: #ffffff;
		border-radius: 4px;

		.service-group {
			height: 100%;
			overflow-y: scroll;
			box-sizing: border-box;
			padding-left: 22px;
			padding-bottom: 22px;
			-ms-overflow-style: none;
			scrollbar-width: none;

			.service-item {
				display: inline-block;
				margin-right: 20px;
				margin-top: 25px;
				margin-bottom: 0px;
				width: 435px;
				height: 100px;
				box-sizing: border-box;
				border-radius: 3px;
				background-color: #f6f6f6;
				border: 1px solid #f2f5fd;

				.item-name-group {
					align-items: center;
					position: relative;
					height: 100%;

					.item-icon {
						position: relative;
						margin-left: 20px;
						margin-right: 10px;
						width: 48px;
						height: 48px;
						background-repeat: no-repeat;
						background-size: 100% 100%;
						background-position: center;
						display: inline-block;
						vertical-align: top;
						margin-top: 20px;

						.device-status-wrap {
							.device-icon {
								position: relative;
								z-index: 2;
								width: 48px;
								height: 48px;
								background-image: url("../assets/home/node/device_setting1.svg");
								background-repeat: no-repeat;
								background-size: 100% 100%;

								.device-status {
									position: absolute;
									bottom: -5px;
									left: 50%;
									transform: translate(-50%, 0);
									width: 31px;
									height: 14px;
									line-height: 14px;
									text-align: center;
									background-color: #1f5de3;
									border-radius: 41px;

									div {
										font-size: 12px;
										color: #f0f0f0;
										transform: scale(0.75);
									}
								}
								.device-status-off {
									background-color: #999999;
								}
							}
							.device-icon-off {
								background-image: url("../assets/home/node/device_setting2.svg");
							}
						}
					}
					.item-text {
						display: inline-block;
						vertical-align: top;
						margin-top: 21px;

						.item-name {
							color: #1c1f28;
							font-size: 14px;
							width: 105px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
						.item-ip {
							margin-top: 14px;
							font-size: 12px;
							color: #666666;
						}
					}

					.xbjf_btn {
						position: absolute;
						right: 125px;
						top: 29px;
						height: 36px;
						line-height: 35px;
						padding-left: 20px;
						width: 90px;
						border: 1px solid #1f5de3;
						border-radius: 18px;
						text-align: center;
						color: #1f5de3;
						font-size: 12px;
						box-sizing: border-box;
						background-image: url(../assets/home/node/item_jdxb_icon.svg);
						background-repeat: no-repeat;
						background-position: 10px center;
						overflow: hidden;
					}

					.xbjf_btn:hover {
						cursor: pointer;
						background-color: #1f5de3;
						color: #ffffff;
						background-image: url(../assets/home/node/item_jdxb_hover_icon.svg);
					}

					.unbind {
						position: absolute;
						right: 20px;
						top: 29px;
						padding-left: 10px;
						border: 1px solid #1f5de3;
						box-sizing: border-box;
						height: 36px;
						line-height: 35px;
						width: 90px;
						color: #1f5de3;
						text-align: center;
						border-bottom-right-radius: 3px;
						border-top-right-radius: 3px;
						cursor: pointer;
						font-size: 12px;
						border-radius: 18px;
					}

					.unbind:hover::before,
					.unbind::before {
						content: "";
						position: absolute;
						top: 10px;
						left: 15px;
						width: 15px;
						height: 15px;
						background-image: url("../assets/home/node/item_setting_hover_icon.svg");
						background-position: center;
						background-size: 100% 100%;
						background-repeat: no-repeat;
					}
					.unbind::before {
						background-image: url("../assets/home/node/item_setting_icon.svg");
					}
					.unbind:hover {
						background-color: #1f5de3;
						color: #f5f5f5;
						box-shadow: 0 0 8px 2px rgba(38, 81, 175, 0.18);
					}
				}
			}

			.service-item:hover {
				box-shadow: 0px 0px 12px 2px rgba(135, 148, 164, 0.16);
				background-color: #edf2fc;
				border: 1px solid #edf0fc;
			}
			.add-device-btn2 {
				position: relative;
				margin-top: 30px;
				text-align: center;
				font-size: 14px;
				color: #1c1f28;
				width: 435px;
				height: 100px;
				line-height: 100px;
				background-color: #f6f6f6;
				border-radius: 3px;
				box-sizing: border-box;
			}
			.add-device-btn2:hover {
				cursor: pointer;
				opacity: 0.8;
			}
			.add-device-btn2::before {
				content: "";
				position: absolute;
				top: 29px;
				left: 118px;
				width: 36px;
				height: 36px;
				background-image: url("../assets/home/node/device4.svg");
				background-size: 100% 100%;
				background-repeat: no-repeat;
				background-position: center;
			}
		}

		.service-group::-webkit-scrollbar {
			display: none;
		}
	}
	.service-group-wrap::after {
		content: "";
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 20px;
		background-color: #ffffff;
		z-index: 2;
	}
}
</style>
